import initHeader from './modules/header';
import initLottie from './modules/lottie';
import initM3 from './modules/m3';
import initWorkHandler from './modules/work-handler';

initHeader()
initLottie()
initM3()
initWorkHandler()